import {createContext, Dispatch} from 'react';


type StateDataItem<T = IGenericDialogContextState, k extends keyof T = keyof T> = { key: keyof T, value: T[k] }


export type GenericDialogContextActions =
    | { type: 'setCtxState'; payload: StateDataItem }

export interface IGenericDialogContextState {
    ctxDisabled: boolean
    ctxLoading: boolean
    dispatch?: Dispatch<GenericDialogContextActions>
}


export const INITIAL_STATE: IGenericDialogContextState = {
    ctxDisabled: false,
    ctxLoading: false
} as IGenericDialogContextState;
export const GenericDialogContext = createContext<IGenericDialogContextState>(INITIAL_STATE as IGenericDialogContextState)
